// Who may open the Assistant: ThirdLine admins (is_admin on a thirdline.io account, as AdminRoutes
// checks) who are also beta users. AskConversationPolicy enforces the same rule on every request.
export const isAssistantUser = (user) =>
  Boolean(user?.is_admin && user?.is_beta && user?.email?.endsWith('@thirdline.io'))

// The organization must also have AI features turned on before a question can be asked.
export const isAssistantEnabled = (user) => Boolean(user?.municipality?.setting?.ai_search_enabled)
